/* unplugin-vue-components disabled */export default defineComponent({
  name: 'CButton',
  props: {
    msg: String
  }
});